import { Link } from "react-router-dom";
import { buildWhatsAppLink } from "@/lib/whatsapp";
import { Logo } from "@/components/site/Logo";

export const Hero = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative pt-32 md:pt-40 pb-24 md:pb-36 overflow-hidden bg-white"
    >
      {/* Editorial campaign marker — MACD Connect period */}
      <div className="hidden md:flex absolute top-28 right-10 items-center gap-3 z-10">
        <span className="w-10 h-px bg-[#0a0a0a]" />
        <span className="eyebrow text-[#6b6b6b]">
          MACD Connect Presencial · 31 de agosto · São Paulo
        </span>
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-end">
      <div className="lg:col-span-7 xl:col-span-6 reveal">
            <div data-testid="hero-brand-logo" className="mb-12 md:mb-16">
              <Logo
                size="xl"
                priority
                className="rounded-[3px] shadow-[0_10px_50px_-18px_rgba(244,197,66,0.55)]"
              />
            </div>

            <h1
              data-testid="hero-headline"
              className="font-display text-[2.6rem] sm:text-5xl md:text-6xl lg:text-[5.2rem] leading-[1.02] tracking-tight text-[#0a0a0a]"
            >
              <span className="italic block">O mercado da beleza mudou.</span>
              Agora o profissional precisa aprender a crescer com{" "}
              <em
                className="italic relative inline-block"
                style={{ fontWeight: 400 }}
              >
                método
                <span className="absolute left-0 right-0 -bottom-1 md:-bottom-2 h-[6px] md:h-[8px] bg-[#f4c542] -z-0 opacity-90" />
              </em>
              .
            </h1>

            <p
              data-testid="hero-subhead"
              className="mt-12 max-w-xl text-[1.05rem] md:text-lg leading-relaxed text-[#3a3a3a]"
            >
              A Oasys Academy forma profissionais da beleza para pensar além
              da cadeira: técnica, comportamento, dados, relacionamento e
              crescimento organizado.
            </p>

            <div className="mt-14 flex flex-wrap items-center gap-8">
              <Link
                to="/macd-connect"
                data-testid="hero-cta-primary"
                className="btn-primary"
              >
                Participar do MACD Connect
                <span aria-hidden>→</span>
              </Link>
              <a
                href="#formacoes"
                data-testid="hero-cta-secondary"
                className="text-link-arrow"
              >
                Ver formações
                <span aria-hidden className="arrow">
                  →
                </span>
              </a>
              <a
                href={buildWhatsAppLink(
                  "Olá! Quero conhecer a Oasys Academy.",
                )}
                target="_blank"
                rel="noreferrer"
                data-testid="hero-cta-tertiary"
                className="text-link-arrow"
              >
                Falar com a Academy
                <span aria-hidden className="arrow">
                  →
                </span>
              </a>
            </div>
          </div>

          <div className="lg:col-span-5 xl:col-span-6 reveal">
            <div className="relative">
              <div className="img-zoom relative aspect-[4/5] lg:aspect-[2/3] bg-[#3a3936]">
                <img
                  src="https://customer-assets.emergentagent.com/job_oasys-academy/artifacts/ey99nph9_Sem%20t%C3%ADtulo%20-%2005%20de%20julho%20de%202026%20%C3%A0s%2016.27.14-5%20%285%29.png"
                  alt="Gilson Ribeiro, fundador da Oasys Academy, segurando tablet e caneta"
                  className="w-full h-full object-cover object-[center_28%]"
                  loading="eager"
                  fetchPriority="high"
                  style={{
                    filter: "contrast(1.03) brightness(1.02)",
                  }}
                />
                {/* Light edge vignette for premium integration */}
                <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(ellipse_at_center,transparent_65%,rgba(10,10,10,0.20)_100%)]" />
              </div>
            </div>
          </div>
        </div>

        {/* Quiet editorial strip — Osklen calm, not promotional marquee */}
        <div className="mt-28 md:mt-40 flex items-baseline justify-between gap-10 border-t border-[#0a0a0a] pt-6">
          <p className="eyebrow text-[#0a0a0a]">
            M · A · C · D — Metodologia autoral
          </p>
          <p className="hidden md:block font-display italic text-base lg:text-lg text-[#3a3a3a]">
            Menos coach. Mais método.
          </p>
          <p className="eyebrow text-[#6b6b6b]">Oasys Hair × Academy</p>
        </div>

        <div className="mt-16 grid grid-cols-3 gap-8 md:gap-12 max-w-3xl">
          <div>
            <p className="font-display text-3xl md:text-5xl text-[#0a0a0a]">
              +20
            </p>
            <p className="eyebrow mt-3">Anos de mercado</p>
          </div>
          <div>
            <p className="font-display text-3xl md:text-5xl text-[#0a0a0a]">
              04
            </p>
            <p className="eyebrow mt-3">Pilares MACD</p>
          </div>
          <div>
            <p className="font-display text-3xl md:text-5xl text-[#0a0a0a]">
              01
            </p>
            <p className="eyebrow mt-3">Método autoral</p>
          </div>
        </div>
      </div>
    </section>
  );
};
